import { INDICES } from "../actionTypes";

const initialState = {
    myFavoritesIndices: [],
    headerIndices: [],
    localIndices: [],
    globalIndices: [],
    indicesFutureData: null,
    isIndicesOverview: false,
    indiceOverviewData: {},
    scrollPosition: 0,
    //Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices -to avoid makign copies of stored indices  --Start
    storedIndices: []
    //Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices -to avoid makign copies of stored indices  --End
};


const indicesReducer = (state = initialState, actions) => {
    switch (actions.type) {
        //Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices -to avoid makign copies of stored indices  --Start
        case INDICES?.UPDATE_LOCAL_INDICES:
            return {
                ...state,
                storedIndices: actions?.payload
            };
        //Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices -to avoid makign copies of stored indices  --End
        case INDICES.GET_INDICES_SUCCESS:
            // Ajitesh 17/05/2024 - Logic to filter out duplicate local index entries from API as happening in 1404
            const noDuplicateLocalIndices = actions.payload.local.filter((value, index, arr) => 
                index === arr.findIndex(t => t.nToken === value.nToken)
            )
            return {
                ...state,
                myFavoritesIndices: actions.payload?.favourites,
                localIndices: noDuplicateLocalIndices,

            };
        case INDICES?.SCROLL_POSITION: {
            return {
                ...state,
                scrollPosition: actions?.payload
            };
        }
        case INDICES.GET_WORLD_INDICES_SUCCESS:
            return {
                ...state,
                globalIndices: actions.payload
            };
        case INDICES.SET_IS_INDICES_OVERVIEW:
            return {
                ...state,
                isIndicesOverview: actions.payload
            };
        case INDICES.GET_INDICES_FUTURE_DATA_SUCCESS:
            return {
                ...state,
                indicesFutureData: actions.payload
            };
        case INDICES.GET_INDICES_FUTURE_DATA_FAILURE:
            return {
                ...state,
                indicesFutureData: actions.payload
            };
        case INDICES.RESET_INDICE_OVERVIEW:
            return {
                ...state,
                indicesFutureData: initialState.indicesFutureData,
                isIndicesOverview: initialState.isIndicesOverview
            };
        case INDICES.SET_INDICE_OVERVIEW_DATA:
            return {
                ...state,
                indiceOverviewData: actions.payload
            };
        //Prachi T - 27-11-2023 :- BT-104813 -- Dashboard Indices - Start
        case INDICES.UPDATE_FAVORITE_INDICES_SUCCESS:
            return {
                ...state,
                myFavoritesIndices: actions.payload
            };
        //Prachi T - 27-11-2023 :- BT-104813 -- Dashboard Indices - End
        // Parshva S - 12/12/2023 - BT-123521 : Breeze - Header Indices Start
        case INDICES.UPDATE_HEADER_INDICES:
            return {
                ...state,
                headerIndices: actions.payload
            }
        // Parshva S - 12/12/2023 - BT-123521 : Breeze - Header Indices End

        default:
            return state;
    }

};

export default indicesReducer;